/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useState, useEffect } from 'react';
import Modal from '../../../../components/Modal';
import { Row, Column } from '../../../../styles/components';
import TarifasTable from '../TarifasTable';
import { formatPrice } from '../../../../utils/currencyFormater';
import CoreService from '../../../../services/core';
import { ArrayFilters } from '../../../../interfaces/ticket';
import { Container } from './styles';

interface TarifasModalProps {
  show: boolean;
  title: string;
  handleClose(): void;
}

interface Tarifa {
  CodigoDaTarifa: number;
  Descricao: string;
  DataFimValidade: string;
  Valor: number;
  IdentifTarifa: string;
}

const TarifasModal: React.FC<TarifasModalProps> = ({
  handleClose,
  show,
  title,
}) => {
  const [loader, setLoader] = useState<boolean>(true);
  const service = { CoreService: new CoreService() };
  const [tarifas, setTarifas] = React.useState<Tarifa[]>([]);
  const [page, setpage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(50);
  const [totalRows] = useState<number>(0);
  const [filters, setFilters] = useState<ArrayFilters>({
    filters: [{ page }, { quantity: perPage }],
  });
  const handleChangePerPage = useCallback(
    async (newPage: number) => {
      setpage(newPage);
      setFilters({ filters: [...filters.filters, { page: newPage }] });
    },
    [filters],
  );

  const handleChangeRowsPerPage = useCallback(
    async (newPerPage: number, OldPerPage: number) => {
      setPerPage(newPerPage);
      setpage(OldPerPage);
      setFilters({
        filters: [
          ...filters.filters,
          { page: OldPerPage },
          { quantity: newPerPage },
        ],
      });
    },
    [filters],
  );

  useEffect(() => {
    async function getTarifas() {
      try {
        const response = await service.CoreService.getTarifasPorLinha();
        setTarifas(response.data.ListaInformacoesDeTarifa);
        setLoader(false);
      } catch (err) {
        setLoader(false);
        console.error(err);
      }
    }
    getTarifas();
  }, []);

  return (
    <Container>
      <Modal show={show} title={title} handleClose={handleClose}>
        <Row>
          <Column large="12" medium="12" small="12" className="tableContainer">
            <TarifasTable
              data={tarifas}
              columns={[
                {
                  name: 'Descrição',
                  selector: 'Descricao',
                },
                {
                  name: 'Código da linha',
                  selector: 'IdentifTarifa',
                },
                {
                  name: 'Valor',
                  selector: 'Valor',
                  cell: ({ Valor }: any) => (
                    <>
                      <div>{formatPrice(Valor)}</div>
                    </>
                  ),
                },
              ]}
              loading={loader}
              totalRows={totalRows}
              perPage={perPage}
              onChangePage={handleChangePerPage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              emptyText="Nenhuma Tarifa cadastrada"
            />
          </Column>
        </Row>
      </Modal>
    </Container>
  );
};

export default TarifasModal;
